/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState, useEffect } from 'react';
import { Grid, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useApolloClient } from '@apollo/client';
import EirTacticalCard from './EirTacticalCard';
import EirInformation from '../eir-information/EirInformation';
import getTacticalOffer from './EirTacticalOffers.util';

import styles from './styles';

const EirTacticalCardContainer = ({ serviceGroupCode = '', title = '' }) => {
  const theme = useTheme();
  const graphql = useApolloClient();
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getTacticalOffers() {
      const data = await getTacticalOffer(graphql, serviceGroupCode);
      if (data && data.length > 0) {
        setLoading(false);
        setCards(data);
      }
    }
    if (serviceGroupCode.length > 0) getTacticalOffers();
  }, [serviceGroupCode]);
  return (
    <>
      {cards?.length > 0 && (
        <Container maxWidth='md' sx={styles(theme).tactOfferContainer}>
          {serviceGroupCode?.length > 0 && (
            <>
              <EirInformation
                title={title}
                style={{
                  title: {
                    color: theme.palette.primary.textColor3,
                  },
                }}
                titleVariant='h2'
              />
              <Grid container spacing={2} sx={styles(theme).tacticalCards_Container}>
                {loading &&
                  new Array(2).fill().map(() => <EirTacticalCard card={[]} loading={loading} />)}
                {!loading &&
                  cards.map((card, index) => (
                    <EirTacticalCard key={index} card={card} loading={loading} />
                  ))}
              </Grid>
            </>
          )}
        </Container>
      )}
    </>
  );
};

export default EirTacticalCardContainer;
